export const useFinalPage = () => {
  const goToDashboard = () => {
    window.location.href = process.env.V2_BASE_URL!;
  };

  return { goToDashboard };
};
